import * as React from 'react';
import { useMutation } from '@apollo/react-hooks';
import { useNavigate, useParams } from 'react-router-dom';
import { AppFormView } from './view';
import { APP_UPDATE, APP_DELETE } from 'const/mutations';
import { useAppQuery } from '../../../types/generated';

export function AppEditForm() {
    const navigate = useNavigate();
    const { id: appId } = useParams<{ id: string }>();
    const APP_LIST_LINK = '/extranet/apps';

    const { data } = useAppQuery({ variables: { id: appId } });

    const selectedApp = data && data.app;
    const dashboardLink = app => '/extranet/apps/' + app.id + '/dashboard';

    const [appUpdate, { loading }] = useMutation(APP_UPDATE, {
        onCompleted({ results }) {
            navigate(dashboardLink(results.node));
        },
    });

    const onSubmit = (values, form, callback) => {
        values.id = appId;
        appUpdate({ variables: values })
            .then(() => callback())
            .catch(err => callback(err));
    };

    const [appDelete, { loading: deleting }] = useMutation(APP_DELETE, {
        onCompleted() {
            navigate(APP_LIST_LINK);
        },
    });

    const onCancel = () => {
        navigate(dashboardLink(selectedApp));
    };

    const onDelete = () => {
        appDelete({ variables: { id: appId } });
    };

    return (
        <AppFormView
            app={selectedApp}
            loading={loading}
            onCancel={onCancel}
            onSubmit={onSubmit}
            deleting={deleting}
            onDelete={onDelete}
        />
    );
}
